import { de, enUS, es, fr, it, ptBR } from 'date-fns/locale';

const localeMap: Record<string, Locale> = {
  en: enUS,
  es: es,
  fr: fr,
  pt: ptBR,
  de: de,
  it: it,
};

export function getDateFnsLocale(language: string): Locale {
  return localeMap[language] || enUS;
}
